import React from "react";
import "./Number.css";
import { fromMmToUnit } from "src/helpers/dimensions";

interface MinMaxLabelProps {
  min: number;
  max: number;
  unit: "mm" | "cm";
  mask?: number;
}

export const MinMaxLabel: React.FC<MinMaxLabelProps> = ({
  min,
  max,
  unit,
  mask = 0,
}) => {
  const displayedMin = fromMmToUnit(min - mask, unit);
  const displayedMax = fromMmToUnit(max - mask, unit);

  return (
    <div className={`number-input `}>
      <div className={`number-input__label number-input`}>
        <div className="start-option-container"></div>
        <span>
          (min. {displayedMin} - max. {displayedMax})
        </span>
      </div>
    </div>
  );
};
